import {
  IBrand,
  isStaffer,
  IStaffer,
  IUser,
} from '@principle-theorem/principle-core/interfaces';
import {
  INamedDocument,
  IReffable,
  isINamedDocument,
  isSameRef,
  multiSwitchMap,
  toNamedDocument,
  undeletedQuery,
  WithRef,
} from '@principle-theorem/shared';
import { compact } from 'lodash';
import { Observable, of, OperatorFunction } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Brand } from '../brand';
import { stafferToNamedDoc } from '../common';
import { OrganisationCache } from '../organisation/organisation-cache';

export function resolveToStaff(
  brand: IReffable<IBrand>
): OperatorFunction<WithRef<IUser>[], (WithRef<IStaffer> | undefined)[]> {
  return (source: Observable<WithRef<IUser>[]>) =>
    source.pipe(multiSwitchMap((user) => resolveToStaffer(brand)(of(user))));
}

export function resolveToStaffer(
  brand: IReffable<IBrand>
): OperatorFunction<WithRef<IUser>, WithRef<IStaffer> | undefined> {
  return (source: Observable<WithRef<IUser>>) =>
    source.pipe(
      switchMap((user) =>
        OrganisationCache.staff.all
          .query$(
            {
              brandRef: brand.ref,
              deleted: false,
            },
            undeletedQuery(Brand.stafferCol(brand))
          )
          .pipe(
            map((staff) =>
              staff.find((staffer) => isSameRef(staffer.user.ref, user.ref))
            )
          )
      )
    );
}

export function toINamedDocuments<T extends object>(): OperatorFunction<
  T[],
  INamedDocument<T>[]
> {
  return (source: Observable<T[]>) =>
    source.pipe(
      map((items: T[]) =>
        compact(
          items.map((item: T) => {
            if (isStaffer(item)) {
              return stafferToNamedDoc(item) as unknown as INamedDocument<T>;
            }

            if (isINamedDocument<T>(item)) {
              return toNamedDocument<T>(item);
            }
          })
        )
      )
    );
}
